module.exports = __webpack_public_path__ + "media/images/promo/essentials-callout-a6ff6320cebc7323213fce226100d939.jpg";